import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import { IApiError } from "../@typings/client";
import { uiStore } from "../mobx/stores/UiStore/UiStore";

export class ValidationErrorHandler {
  static showErrorInfo(msg: string, errors: IApiError[]) {
    uiStore.notify({
      message: (
        <>
          <Grid container direction={"column"}>
            <Grid item>
              <Box marginBottom={1}>{msg}</Box>
            </Grid>
            {errors.map((error) => (
              <Grid item key={error.id}>
                <Box marginLeft={2}>- {error.detail}</Box>
              </Grid>
            ))}
          </Grid>
        </>
      ),
      options: { autoHideDuration: 10000, variant: "error" },
      action: (closeSnackbar) => (key) => (
        <>
          <IconButton
            style={{
              paddingLeft: "8px",
            }}
            size={"small"}
            onClick={() => closeSnackbar(key)}
          >
            <Close
              style={{
                color: "white",
              }}
            />
          </IconButton>
        </>
      ),
    });
  }
}
